<div class="genie-page">
  <!-- Page Header Section -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <p class="genie-page-title">{{ 'Products' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Manage your products across all channels.' | translate }}</p>
    </div>
    <!-- Mobile product count -->
    <div class="header-right-mobile" *ngIf="mobile">
      <div class="mobile-usage-inner">
        <div class="mobile-usage-icon">
          <img src="/assets/icons/cube.svg" [alt]="'products cube' | translate" />
        </div>
        <div class="mobile-usage-content">
          <div class="mobile-usage-row">
            <span class="mobile-usage-label">{{ 'Products' | translate }}</span>
            <div class="mobile-usage-count">
              <span class="usage-current">{{ getCurrentProductCount() }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-right" *ngIf="!mobile">
      <div class="usage-counter">
        <span class="usage-current">{{ getCurrentProductCount() }}</span>
        <span class="usage-total">{{ 'Products' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Main Content Card -->
  <div class="genie-content-card">
    <!-- Empty State -->
    <div class="genie-empty-state" *ngIf="productsService.totalProductsCount === 0">
      <div class="empty-image">
        <img src="assets/images/products/add-product.png" alt="" />
      </div>
      <app-backup *ngIf="this.loginService.getCurrentUser().admin" backupNode="products"></app-backup>
      <div class="empty-state-actions">
        <button class="genie-btn primary" [routerLink]="['new-product']" *ngIf="!this.vendor.vendorsList.length && !builderService.isStockManager">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3.33334V12.6667M3.33334 8H12.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          {{ 'Add New Product' | translate }}
        </button>
        <button class="genie-btn importUrl magic-import" (click)="openSocialImportDialog()" *ngIf="!builderService.isStockManager">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" fill="#388CA9" opacity="0.2" stroke="#388CA9" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M20 1v5M22.5 3.5h-5" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ 'Import from Social' | translate }}
        </button>
      </div>
    </div>

    <!-- Products Table Section -->
    <div [hidden]="productsService.totalProductsCount === 0" class="table-section">
      <app-stepper step="4" *ngIf="builderService.getTour()"></app-stepper>

      <!-- Toolbar -->
      <div class="genie-toolbar">
        <div class="toolbar-left">
          <!-- Category Filter Dropdown -->
          <div class="filter-dropdown category-dropdown-container" *ngIf="categoriesService.allCategories && categoriesService.allCategories.length > 0">
            <button #searchWrapper class="filter-btn" (click)="toggleCategoryDropdown($event)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 2.5L5.5 2.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 2.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 6H8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 6H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 9.5H5.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 9.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 10.5V8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 3.5V1.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 7V5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span>{{ categoriesService.selectedCategoryName | translate }}</span>
              <svg class="arrow" [class.open]="showCategoryDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="dropdown-panel" *ngIf="showCategoryDropdown">
              <div class="dropdown-search">
                <input type="text" #myInput placeholder="{{ 'Search categories...' | translate }}" [(ngModel)]="categoriesService.categorySearch" (input)="filterCategories()" (click)="$event.stopPropagation()" />
              </div>
              <div class="dropdown-options">
                <div class="dropdown-option" [class.selected]="categoriesService.selectedCategory === 'all' && !categoriesService.selectedSubCategoryFilter" (click)="selectCategory('all', 'All Categories')">{{ 'All Categories' | translate }}</div>
                <ng-container *ngFor="let cat of categoriesService.filteredCategories">
                  <div class="dropdown-option" [class.selected]="categoriesService.selectedCategory === cat.categoryId && !categoriesService.selectedSubCategoryFilter" (click)="selectCategory(cat.categoryId, cat.categoryName)">
                    {{ cat.categoryName }}
                  </div>
                  <div *ngFor="let sub of cat.subcategories" class="dropdown-option subcategory-option" [class.selected]="categoriesService.selectedSubCategoryFilter === sub.subCategoryId" (click)="selectCategory(sub.subCategoryId, sub.subcategory, true)">
                    <span class="sub-indicator">—</span> {{ sub.subcategory }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Sort Dropdown -->
          <div class="filter-dropdown sort-dropdown-container">
            <button class="filter-btn" (click)="toggleSortDropdown($event)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 1.5V10.5M3.5 10.5L1.5 8.5M3.5 10.5L5.5 8.5" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.5 10.5V1.5M8.5 1.5L6.5 3.5M8.5 1.5L10.5 3.5" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ getSortLabel() | translate }}</span>
              <svg class="arrow" [class.open]="showSortDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="dropdown-panel" *ngIf="showSortDropdown">
              <div class="dropdown-options">
                <div *ngFor="let opt of sortOptions" class="dropdown-option" [class.selected]="sortBy === opt.value" (click)="selectSort(opt.value)">
                  {{ opt.label | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search Input (direct toolbar child so it can go full-width on mobile) -->
        <div class="search-input-wrapper toolbar-search">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input type="text" (input)="applyFilter()" [(ngModel)]="searchText" placeholder="{{ 'Search product...' | translate }}" />
        </div>

        <div class="toolbar-right">
          <!-- Delete Selected Button (desktop only) -->
          <button class="genie-btn danger hide-mobile" (click)="deleteCheckedItems()" *ngIf="hasCheckedItems && !builderService.isStockManager">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.75 3.5H12.25M5.25 6.125V10.375M8.75 6.125V10.375M2.625 3.5L3.5 11.375C3.5 11.8391 3.68437 12.2842 4.01256 12.6124C4.34075 12.9406 4.78587 13.125 5.25 13.125H8.75C9.21413 13.125 9.65925 12.9406 9.98744 12.6124C10.3156 12.2842 10.5 11.8391 10.5 11.375L11.375 3.5M4.375 3.5V1.75C4.375 1.51794 4.46719 1.29538 4.63128 1.13128C4.79538 0.967187 5.01794 0.875 5.25 0.875H8.75C8.98206 0.875 9.20462 0.967187 9.36872 1.13128C9.53281 1.29538 9.625 1.51794 9.625 1.75V3.5"
                stroke="#DC2626"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Assign Category Button + Panel (desktop only) -->
          <div class="assign-category-dropdown-container hide-mobile" *ngIf="hasCheckedItems && !builderService.isStockManager && categoriesService.allCategories?.length > 0">
            <button class="genie-btn secondary" (click)="toggleAssignCategoryPanel($event)">
              {{ 'Assign Category' | translate }}
            </button>
            <div class="assign-category-panel" *ngIf="showAssignCategoryPanel" (click)="$event.stopPropagation()">
              <div class="assign-panel-title">{{ 'Assign to Category' | translate }}</div>

              <div class="assign-panel-field">
                <label>{{ 'Categories' | translate }}</label>
                <div class="multi-select-list">
                  <div *ngFor="let cat of categoriesService.allCategories" class="multi-select-item" (click)="toggleBulkCategory(cat.categoryId)">
                    <mat-checkbox [checked]="selectedBulkCategoryIds.includes(cat.categoryId)" (click)="$event.stopPropagation(); toggleBulkCategory(cat.categoryId)" class="custom-checkbox"></mat-checkbox>
                    <span>{{ cat.categoryName }}</span>
                  </div>
                </div>
              </div>

              <div class="assign-panel-field" *ngIf="bulkAvailableSubcategories.length > 0">
                <label>{{ 'Subcategories' | translate }}</label>
                <div class="multi-select-list">
                  <div *ngFor="let sub of bulkAvailableSubcategories" class="multi-select-item" (click)="toggleBulkSubCategory(sub.subCategoryId)">
                    <mat-checkbox [checked]="selectedBulkSubCategoryIds.includes(sub.subCategoryId)" (click)="$event.stopPropagation(); toggleBulkSubCategory(sub.subCategoryId)" class="custom-checkbox"></mat-checkbox>
                    <span>{{ sub.subcategory }}</span>
                  </div>
                </div>
              </div>

              <button class="genie-btn primary assign-apply-btn" [disabled]="selectedBulkCategoryIds.length === 0" (click)="bulkAssignCategory()">
                {{ 'Apply' | translate }}
              </button>
            </div>
          </div>

          <!-- Export to Excel Button -->
          <button class="genie-btn export" *ngIf="!mobile" (click)="exportAllProductData()" [disabled]="isExporting">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.4375 7.4375C0.4375 9.0874 0.4375 9.91235 0.950063 10.4249C1.46263 10.9375 2.28758 10.9375 3.9375 10.9375H7.4375C9.0874 10.9375 9.91235 10.9375 10.4249 10.4249C10.9375 9.91235 10.9375 9.0874 10.9375 7.4375" stroke="#388CA9" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.6888 0.4375V8.02083M5.6888 8.02083L8.02214 5.46875M5.6888 8.02083L3.35547 5.46875" stroke="#388CA9" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ (hasCheckedItems ? 'Export Selected' : 'Export to Excel') | translate }}
          </button>

          <!-- Import from Social Media Button (desktop only) -->
          <button class="genie-btn importUrl magic-import hide-mobile" (click)="openSocialImportDialog()" *ngIf="!builderService.isStockManager">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" fill="#388CA9" opacity="0.2" stroke="#388CA9" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M20 1v5M22.5 3.5h-5" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ 'Import from Social' | translate }}
          </button>

          <!-- Mobile: dots dropdown -->
          <div class="actions-dropdown show-mobile" (click)="$event.stopPropagation()">
            <button class="dots-btn" (click)="showActionsMenu = !showActionsMenu" [class.active]="showActionsMenu">
              <img src="assets/icons/three_dots.svg" alt="more actions" />
            </button>
            <div class="actions-menu" *ngIf="showActionsMenu">
              <button class="actions-menu-item" (click)="openSocialImportDialog(); showActionsMenu = false" *ngIf="!builderService.isStockManager">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M20 1v5M22.5 3.5h-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ 'Import from Social' | translate }}</span>
              </button>
              <button class="actions-menu-item" (click)="exportAllProductData(); showActionsMenu = false">
                <svg width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.4375 7.4375C0.4375 9.0874 0.4375 9.91235 0.950063 10.4249C1.46263 10.9375 2.28758 10.9375 3.9375 10.9375H7.4375C9.0874 10.9375 9.91235 10.9375 10.4249 10.4249C10.9375 9.91235 10.9375 9.0874 10.9375 7.4375" stroke="currentColor" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.6888 0.4375V8.02083M5.6888 8.02083L8.02214 5.46875M5.6888 8.02083L3.35547 5.46875" stroke="currentColor" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{ (hasCheckedItems ? 'Export Selected' : 'Export to Excel') | translate }}</span>
              </button>

              <button class="actions-menu-item danger-item" (click)="deleteCheckedItems(); showActionsMenu = false" *ngIf="hasCheckedItems && !builderService.isStockManager">
                <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75 3.5H12.25M5.25 6.125V10.375M8.75 6.125V10.375M2.625 3.5L3.5 11.375C3.5 11.8391 3.68437 12.2842 4.01256 12.6124C4.34075 12.9406 4.78587 13.125 5.25 13.125H8.75C9.21413 13.125 9.65925 12.9406 9.98744 12.6124C10.3156 12.2842 10.5 11.8391 10.5 11.375L11.375 3.5M4.375 3.5V1.75C4.375 1.51794 4.46719 1.29538 4.63128 1.13128C4.79538 0.967187 5.01794 0.875 5.25 0.875H8.75C8.98206 0.875 9.20462 0.967187 9.36872 1.13128C9.53281 1.29538 9.625 1.51794 9.625 1.75V3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ 'Delete Selected' | translate }}</span>
              </button>
            </div>
            <div class="actions-backdrop" *ngIf="showActionsMenu" (click)="showActionsMenu = false"></div>
          </div>

          <!-- Add Product Button -->
          <button class="genie-btn primary" [routerLink]="['new-product']" [ngClass]="builderService.getTour() ? 'glow' : ''" *ngIf="!this.vendor.vendorsList.length && !builderService.isStockManager">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ 'Add Product' | translate }}
          </button>
        </div>
      </div>

      <!-- Data Table -->
      <div class="genie-table-wrapper">
        <table class="genie-table" *ngIf="!mobile">
          <thead>
            <tr>
              <th class="col-checkbox" *ngIf="!builderService.isStockManager">
                <mat-checkbox #selectAllCheckbox (change)="toggleSelectAllItems()" class="custom-checkbox"></mat-checkbox>
              </th>
              <th class="col-center">{{ 'Product' | translate }}</th>
              <th class="col-center">{{ 'Stock' | translate }}</th>
              <th class="col-center">{{ 'Price' | translate }}</th>
              <th class="col-center">{{ 'Sku' | translate }}</th>
              <th class="col-center">{{ 'Date' | translate }}</th>
              <th class="col-center">{{ 'Publish' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of displayedProducts; let i = index" [class.selected-row]="product.checked">
              <td class="col-checkbox" *ngIf="!builderService.isStockManager">
                <mat-checkbox class="custom-checkbox" [(ngModel)]="product.checked" (change)="onCheckboxItem()"></mat-checkbox>
              </td>
              <td>
                <div class="product-cell">
                  <div class="product-image">
                    <img [src]="helpers.getArrayValue(product.imageUrl) || 'assets/images/empty-image.png'" [alt]="product.productName" />
                  </div>
                  <div class="product-info">
                    <span class="product-name">{{ product.productName | slice: 0 : 20 }}{{ product.productName?.length > 20 ? '...' : '' }}</span>
                    <span class="product-category">{{ getCategoryLabels(product) }}</span>
                  </div>
                </div>
              </td>
              <td class="col-center">{{ product.productStock >= 0 ? (product.productStock == 0 ? ('Out of Stock' | translate) : product.productStock) : ('In Stock' | translate) }}</td>
              <td class="col-center">{{ getProductPrice(product) }}</td>
              <td class="col-center">{{ getProductSKU(product) }}</td>
              <td class="col-center">{{ product.date | date:'yyyy/MM/dd HH:mm:ss' }}</td>
              <td class="col-center">
                <label class="toggle-switch">
                  <input type="checkbox" [checked]="product.publish !== null && product.publish !== undefined ? product.publish : true" (change)="onToggleChange(product, $event)" [disabled]="builderService.isStockManager" />
                  <span class="toggle-slider"></span>
                </label>
              </td>
              <td class="col-actions">
                <div class="genie-action-buttons">
                  <button class="genie-icon-btn edit" (click)="!builderService.getTour() ? editProduct(product.Id) : ''" [disabled]="builderService.getTour()">
                    <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.25996 11.8369L11.8369 4.25996C12.1913 3.90555 12.3685 3.72834 12.4633 3.53718C12.6435 3.17347 12.6435 2.74645 12.4633 2.38274C12.3685 2.19158 12.1913 2.01437 11.8369 1.65996C11.4825 1.30555 11.3053 1.12834 11.1141 1.03361C10.7504 0.85338 10.3234 0.85338 9.95967 1.03361C9.76851 1.12834 9.59132 1.30555 9.23694 1.65996L1.65996 9.2369C1.28422 9.6126 1.09635 9.80051 0.997394 10.0394C0.898438 10.2783 0.898438 10.544 0.898438 11.0754V12.5984H2.42148C2.95286 12.5984 3.21855 12.5984 3.45745 12.4994C3.69635 12.4005 3.88422 12.2126 4.25996 11.8369Z"
                        stroke="#ADADAD"
                        stroke-width="1.4625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path d="M6.75 12.5996H10.65" stroke="#ADADAD" stroke-width="1.4625" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.375 2.52344L10.975 5.12344" stroke="#ADADAD" stroke-width="1.4625" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <button *ngIf="!builderService.isStockManager" class="genie-icon-btn delete" (click)="!builderService.getTour() ? openDeleteModal(product.Id, helpers.getArrayValue(product.imageUrl), product.productName) : ''" [disabled]="builderService.getTour()">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438"
                        stroke="#ADADAD"
                        stroke-width="1.467"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile Card List -->
        <div class="mobile-card-list" *ngIf="mobile">
          <div class="mobile-card" *ngFor="let p of displayedProducts" [class.selected-row]="p.checked">
            <div class="card-top">
              <div class="card-product">
                <mat-checkbox class="custom-checkbox" *ngIf="!builderService.isStockManager" [(ngModel)]="p.checked" (change)="onCheckboxItem()"></mat-checkbox>
                <div class="card-image">
                  <img [src]="helpers.getArrayValue(p.imageUrl) || 'assets/images/empty-image.png'" [alt]="p.productName" />
                </div>
                <div class="card-info">
                  <span class="card-name">{{ p.productName | slice: 0 : 22 }}{{ p.productName?.length > 22 ? '...' : '' }}</span>
                  <span class="card-category">{{ getCategoryLabels(p) }}</span>
                </div>
              </div>
              <div class="card-actions">
                <label class="toggle-switch">
                  <input type="checkbox" [checked]="p.publish !== null && p.publish !== undefined ? p.publish : true" (change)="onToggleChange(p, $event)" [disabled]="builderService.isStockManager" />
                  <span class="toggle-slider"></span>
                </label>
                <button class="genie-icon-btn edit" (click)="editProduct(p.Id)">
                  <svg width="3" height="13" viewBox="0 0 3 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41667 6.75C1.78486 6.75 2.08333 6.45152 2.08333 6.08333C2.08333 5.71514 1.78486 5.41667 1.41667 5.41667C1.04848 5.41667 0.75 5.71514 0.75 6.08333C0.75 6.45152 1.04848 6.75 1.41667 6.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.41667 2.08333C1.78486 2.08333 2.08333 1.78486 2.08333 1.41667C2.08333 1.04848 1.78486 0.75 1.41667 0.75C1.04848 0.75 0.75 1.04848 0.75 1.41667C0.75 1.78486 1.04848 2.08333 1.41667 2.08333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.41667 11.4167C1.78486 11.4167 2.08333 11.1182 2.08333 10.75C2.08333 10.3818 1.78486 10.0833 1.41667 10.0833C1.04848 10.0833 0.75 10.3818 0.75 10.75C0.75 11.1182 1.04848 11.4167 1.41667 11.4167Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button *ngIf="!builderService.isStockManager" class="genie-icon-btn delete" (click)="openDeleteModal(p.Id, helpers.getArrayValue(p.imageUrl), p.productName)">
                  <svg width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438" stroke="currentColor" stroke-width="1.467" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="card-meta">
              <div class="meta-item">
                <span class="meta-label">{{ 'Price' | translate }}</span>
                <span class="meta-value">{{ getProductPrice(p) }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ 'Stock' | translate }}</span>
                <span class="meta-value" [class.stock-in]="p.productStock !== 0" [class.stock-out]="p.productStock === 0">
                  {{ p.productStock == 0 ? ('Out of Stock' | translate) : p.productStock >= 0 ? p.productStock : ('In Stock' | translate) }}
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ 'SKU' | translate }}</span>
                <span class="meta-value">{{ getProductSKU(p) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Custom Pagination -->
      <div class="genie-pagination">
        <div class="pagination-pageSize">
          <span class="pageSize-label">{{ 'Items per page' | translate }}:</span>
          <select class="pageSize-select" [(ngModel)]="productsService.pageSize" (change)="changePageSize(productsService.pageSize)">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
        </div>
        <div class="pagination-info">
          <span class="current-page">{{ productsService.pageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ Math.ceil(productsService.paginationCount / productsService.pageSize) || 1 }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn prev" [disabled]="productsService.pageIndex === 0" (click)="previousPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button class="page-btn next" [disabled]="productsService.pageIndex >= Math.ceil(productsService.paginationCount / productsService.pageSize) - 1" (click)="nextPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Hidden Mat Paginator for internal state management -->
      <mat-paginator class="hidden-paginator" [length]="productsService.paginationCount" [disabled]="productsService.fetchingInProgress" [pageSize]="productsService.pageSize" [pageSizeOptions]="[5, 10, 50, 100]" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>

<app-delete-confirm-modal
  [visible]="showDeleteModal"
  [itemName]="productToDeleteName"
  itemType="Product"
  (confirmed)="confirmDeleteProduct()"
  (cancelled)="closeDeleteModal()">
</app-delete-confirm-modal>
